import React, { Component } from "react";
import { Link } from "react-router-dom";
import { callApi, API_ENDPOINT } from "../../utils/api";
import {
  clearDocGenTimeout,
  extractAxiosDocGenError,
  isDocGenFailedResponse,
  isDocGenQueued,
  docGenFailureMessage,
  readDocGenTimeout,
  writeDocGenTimeout,
  releaseDocGenClickFreeze,
  pollGeneratedDocx,
  DOC_GEN_TIMEOUT_SEC,
  failWithDocGenTimeout,
  isDocGenWorkerDownError,
} from "../../utils/docGenerationTimeout";
import Select from "react-select";
import MaskedInput from "react-text-mask";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore,
} from "react-toasts";
import _ from "lodash";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { CircularProgress } from "@material-ui/core";
import edit from "../../assets/images/edit.svg";
import VerificationEOD from "./verificationEod";
import ReactFileReader from "react-file-reader";
import CountdownTimer from "../file/CountdownTimer";
import MissingLOD from "../workFileVerificationList/missingLOD";
import DataModel from "../workFileVerificationList/sopDataModel";
import PDFHighlighter from "../PDF-Highlighter";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import "bootstrap/dist/css/bootstrap.css";
import HintAboutFile from "./HintAboutFile";
import { saveAs } from "file-saver";
import moment from "moment";
import { isEmpty } from "lodash";

declare var $: any;
interface AllProps {
  history: any;
  match: any;
  location: any;
}
export class WorkFileDetails extends Component<AllProps> {
  state = {
    report: "",
    rep_id: "",
    data: DataModel,
    remote_users: [],
    isapproved: 0,
    office_users: [],
    documents: [],
    selectedDoc: "",
    qaList: [],
    currentIndex: -1,
    bank: [],
    bankBranch: [],
    lawHandBranch: [],
    selectedBank: "",
    selectedBranch: "",
    selectedLawBranch: "",
    inEcFinalNotes: "",
    date: "",
    holdVal: "",
    isLoading: false,
    showConfirmModal: false,
    showExitConfirmModal: false,
    templateChangedSinceLastSave: false,
    scrollPosition: 0,
    selectedTemplate: null,
    isSaving: false,
    isSubmitting: false,
    isSaved: false,
    docList: [],
    scrutinyList: [],
    schedulesList: [],
    pre_disbursal_list: [],
    post_disbursal_list: [],
    checklist_tracing_ec: [],
    ec_title_text: "",
    hasTracingHistory: [],
    hasTracingPossession: [],
    hasThereSuch: "",
    hasInfinal: "",
    hasTracingSaleAgreement: [],
    errorLocationOptions: [
      { value: "Schedule of Property", label: "Schedule of Property" },
      { value: "Tracing of History", label: "Tracing of History" },
      { value: "Revenue Record", label: "Revenue Record" },
      { value: "Encumbrance Certificate", label: "Encumbrance Certificate" },
      { value: "Post/Pre Disbursement", label: "Post/Pre Disbursement" },
      { value: "Remarks", label: "Remarks" },
      {
        value: "List of documents(To be Collected)",
        label: "List of documents(To be Collected)",
      },
      { value: "Nil", label: "Nil" },
    ],
    errorDetails: "",
    selectedErrorLocations: [],
    bank_id: null,
    bank_templates: [],
    info: {
      lawhands_branch: "",
      verify_officer: "",
      process_officer: "",
      deviation_officer: "",
      rectify_officer: "",
      app_id: "",
      doc_request: "",
      file_name: "",
      file_status: "",
      verify: "",
      report_status: "",
      pending: "",
      closed: "",
      total: "",
      org_bank_id: "",
      productId: "",
      post_required_status: "",
    },
    holdType: "Hold",
    isshowsavsubmit: false,
    holdreason: "",
    notes: "",
    document: "",
    isIframeLoading: false,
    isDocShow: false,
    currentFileId: null,
    fileFrameId: 1,
    mainFrameId: 1,
    isMainFrameLoading: false,
    isSideFrameLoading: false,
    action: "",
    reason: "",
    overviewReport: "",
    timer: 0,
    generationTimedOut: false,
    generationError: "",
    initialTimeInMinutes: 0,
    verification: {
      highlight: false,
      dataEntry: false,
      flowChart: false,
      hintFile: false,
      errorIdentified: false,
      noOflod: "",
      errorSection: [],
      otherSection: "",
      errorTypes: [],
      errorDetails: "",
      totalTime: "",
    },
    uploadFile: {
      base64: "",
      fileList: [{ name: "" }],
    },
    branches: [],
    highlights: [],
    isHightlightsLoaded: false,
    rotation: 0,
    documentHeight: 800,
    velocityEqualToMove: false,
    enableVelocity: false,
    isOnLoading: false,
    currentFileType: "",
    final_approval_status: "",
    final_approval_taken_status: "",
    isFinalApprovalLoading: false,
    blockdownload: "",
    fileOpinionType: "",
    filestatus: "",
    serverLocalFileName: "",
    isComplete: true,
    lastUploadedDocument: {
      pdf: null,
      docx: null,
    },
    updateDownloadData: {
      reasonForDownload: [],
      updatedDetails: [],
    },
    isEdited: false,
    checklist: {
      /** GENERAL DETAILS **/
      generalDetails: [
        {
          label: "Borrower & Property Owner Names Verified with Aadhar Name",
          checked: false,
        },
        { label: "App ID Updated Correctly", checked: false },
      ],

      /** SCHEDULE OF PROPERTY **/
      scheduleOfProperty: [
        { label: "Old & New Survey Numbers Verified", checked: false },
        {
          label: "New Survey Number Verified with Patta Extract",
          checked: false,
        },
        {
          label: "Title Deed Extent Verified with Patta Extract Extent",
          checked: false,
        },
        {
          label: "Door No. Mentioned as per Property Tax Receipt",
          checked: false,
        },
        { label: "Boundaries (Of/By) Directions Verified", checked: false },
        {
          label: "Road / Pathway Approach Available in Boundaries",
          checked: false,
        },
        {
          label: "Boundary Details (North, South, East, West) Verified",
          checked: false,
        },
        {
          label:
            "Measurement Details (Sq. Ft., Acres, Hectares, etc.) Verified",
          checked: false,
        },
        {
          label:
            "Village / Taluk / Regd. District / SRO / Street / Layout Name Mentioned Correctly in Address",
          checked: false,
        },
      ],

      /** TRACING OF HISTORY **/
      tracingOfHistory: [
        { label: "Flow / Chain Link Without Gaps", checked: false },
        { label: "Will Deed Conditions Verified", checked: false },
        { label: "Settlement Deed Conditions Verified", checked: false },
        {
          label:
            "HSD / Namuna Patta Conditions Verified; If Conditions Not Fulfilled, NOC Obtained",
          checked: false,
        },
      ],

      /** TRACING OF POSSESSION **/
      tracingOfPossession: [
        {
          label:
            "In Patta / TSLR Extract, Land Classification (Nanjai / Punjai) Verified",
          checked: false,
        },
      ],

      /** ENCUMBRANCE CERTIFICATE **/
      encumbranceCertificate: [
        {
          label: "EC Updated Till Date Obtained for Title Survey Number",
          checked: false,
        },
        {
          label: "Village / SRO / Survey No. / Extent Verified with Title Deed",
          checked: false,
        },
        { label: "Title Deed Entry Reflected in EC Verified", checked: false },
        {
          label: "Any Sale Entry Before/After Title Deed Entry Verified",
          checked: false,
        },
        {
          label: "Court Attachments / Cancellation Entries Verified",
          checked: false,
        },
        {
          label: "Sale Agreement / Cancellation Entries Verified",
          checked: false,
        },
        {
          label: "Mortgage / Discharge Receipt Entries Verified",
          checked: false,
        },
        {
          label:
            "Lease Agreement / Cancellation Verified; If Lease Not Cancelled, NOC Obtained",
          checked: false,
        },
      ],

      /** LIST OF DOCUMENTS **/
      documentList: [
        {
          label: "For Partition Deed: Original / Simultaneous Copy Verified",
          checked: false,
        },
        { label: "Original Documents of Same Extent Verified", checked: false },
        {
          label: "Xerox Copies of Larger Extent Documents Verified",
          checked: false,
        },
      ],
    },
  };
  document = {
    base: "",
    numPages: 0,
    pageNumber: 1,
  };
  timeoutId: any = null;
  intervalId: NodeJS.Timeout | null = null;
  generationTimeoutTriggered: boolean = false;

  countdownTimerRef: CountdownTimer | null = null;
  // Add this to your class properties (after intervalId declaration)
  qaContainerRef: React.RefObject<HTMLDivElement> = React.createRef();
  componentDidMount() {
    this.setState({ data: DataModel });
    this.getBank();
    this.getFormData();
    this.getLawHandsBranches();
    this.getFiles();
    var docOverview = localStorage.getItem("overviewDocument");
    if (docOverview != null) {
      this.setState({ overviewReport: docOverview, enableRefresh: true });
      $("#root").unbind();
    } else {
      this.getFileOverview();
    }
    this.getDocList();
    this.getFileQA();
    // this.getScrutinizedDocs();
    this.getGeneralDetail();
    this.getTracingHistory();
    this.getReportParagraphEC();
    this.getPreDisbursal();
    this.getFileDetails();
    this.getScrutinizedDocs();
    this.getPostDisbursal();
    this.blockdownload();
    this.getUpdateReasonData();
    const savedError = readDocGenTimeout(this.props.match.params.id);
    if (savedError) {
      this.setState({
        generationTimedOut: true,
        generationError: savedError,
        isIframeLoading: false,
      });
    } else {
      this.intervalId = setInterval(() => {
        this.incrementTimer();
      }, 1000);
      setTimeout(() => {
        this.scrutinyReport();
      }, 2000);
    }
    setTimeout(() => {
      this.getTemplates();
    }, 1500);
  }
  componentWillUnmount() {
    this.stopPollingAndTimer();
  }
  componentDidUpdate(prevProps, prevState) {
    // When file info is loaded and templates are available, initialize template
    if (
      !prevState.info.org_bank_id &&
      this.state.info.org_bank_id &&
      this.state.bank_templates.length > 0 &&
      !this.state.bank_id
    ) {
      this.initializeTemplateFromFileInfo();
    }
  }

  initializeTemplateFromFileInfo = () => {
    const { info, bank_templates, bank_id } = this.state;

    if (!info.org_bank_id || bank_templates.length === 0 || bank_id) {
      return;
    }

    const user: any = localStorage.getItem("user");
    const role_label = user ? JSON.parse(user)["role_label"] : "";

    let filterTemp: any[] = bank_templates;

    // Filter templates based on user role
    if (role_label !== "Admin" && role_label !== "Super Admin") {
      filterTemp = bank_templates.filter(
        (temp: any) =>
          temp?.bank_id === info.org_bank_id &&
          temp?.product_id === info.productId &&
          Array.isArray(temp?.lawhands_branch) &&
          temp.lawhands_branch.includes(info.lawhands_branch),
      ) as any[];
    }

    if (filterTemp.length > 0) {
      // Try to find template matching the file's bank template id
      const fileTemplate: any = filterTemp.find(
        (temp: any) => temp.id === (info as any).bank_id,
      );

      const newBankId: any = fileTemplate
        ? fileTemplate.id
        : (filterTemp[0] as any).id;

      this.setState({ bank_id: newBankId }, () => {
        const selectedTemp: any = filterTemp.find(
          (t: any) => t.id === newBankId,
        );
        if (selectedTemp) {
          localStorage.setItem("bankTemplateName", selectedTemp.name || "");
          localStorage.setItem("bankTemplatemode", selectedTemp.mode || "");
        }

        // Trigger template save
        this.saveTemplate(newBankId);
      });
    }
  };
  saveTemplate = (val) => {
    if (!val) return;

    callApi("POST", "bank_temp_save.php", {
      id: this.props.match.params.id,
      bank_id: val,
    })
      .then((res) => res.data)
      .then((response) => {
        this.setState({ workfileEnable: false });
        localStorage.removeItem("BankTemplate");
        localStorage.removeItem("overviewDocument");

        // Update localStorage with new template info
        const selectedTemp: any = this.state.bank_templates.find(
          (t: any) => t.id === val,
        );
        if (selectedTemp) {
          localStorage.setItem("bankTemplateName", selectedTemp.name || "");
          localStorage.setItem("bankTemplatemode", selectedTemp.mode || "");
        }

        this.setState({
          isMainFrameLoading: true,
          isIframeLoading: true,
          overviewReport: "",
        });
        this.scrutinyReport();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  handleHoldFile = async () => {
    this.setState({ holdVal: true });
    const { holdreason, holdType } = this.state;

    if (isEmpty(holdreason) || isEmpty(holdType)) {
      ToastsStore.error("Please Select Type and Provide Reason to Hold");
      return;
    }

    // if (holdType == "Hold Query Raised") {
    //   if (newQueryList && newQueryList.length > 0) {
    //     const isValid = await this.validateQuery(newQueryList);
    //     if (isValid) {
    //       await this.updateNewQueryList();
    //     } else {
    //       ToastsStore.error("Please fill all the required fields");
    //       return;
    //     }
    //   }
    // } else {
    this.holdFile();
    // }
  };
  finallapprovaltime(type, holdType) {
    const props: any = this.props;
    const loginuser: any = localStorage.getItem("user1");
    var now = new Date();
    var date = now.toLocaleDateString();
    var time = now.toLocaleTimeString();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const currenttime = `${hours}:${minutes}:${seconds}`;
    const currentdate = moment(date).format("YYYY-MM-DD");
    let obj;
    if (type == "hold") {
      obj = {
        id: props.match.params.id,
        verification_hold_time: currenttime,
        verification_hold_date: currentdate,
        verification_hold_by: JSON.parse(loginuser),
        reason: holdType,
        created_by: JSON.parse(loginuser),
        color: "gray",
      };
    }
    callApi("POST", "time_update.php", obj)
      .then((res) => res.data)
      .then((response) => { });
  }
  holdFile = () => {
    const { holdreason, holdType } = this.state;

    const props: any = this.props;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    this.setState({ isLoading: true });
    const obj = {
      file_id: props.match.params.id,
      hold_by: userId,
      reason: holdreason,
      holdType: holdType,
    };
    callApi("POST", "hold_file.php", obj)
      .then((res) => res.data)
      .then((response) => {
        if (response.statuscode == 200) {
          ToastsStore.success(response.message);
          $("#holdModal").modal("hide");
          this.finallapprovaltime("hold", holdType);
          this.setState({ holdVal: false, holdreason: "", isLoading: false });
          localStorage.removeItem("currentfileId");
          this.props.history.push("/final-approval-inprogress");
        } else {
          ToastsStore.error(response.message);
        }
      });
  };
  onchange = (e: any) => {
    e.persist();
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (
          this.state.holdType == "Hold Query Raised" &&
          e.target.name == "holdType"
        ) {
          // this.addQueryList();
        } else if (
          this.state.holdType == "Hold" &&
          e.target.name == "holdType"
        ) {
          this.setState({ newQueryList: [] });
        }
      },
    );
  };
  getUpdateReasonData = () => {
    const reasonData: any = this.state.updateDownloadData;
    callApi("POST", "dashboard_log.php", { id: this.props.match.params.id })
      .then((res) => res.data)
      .then((result) => {
        let { lastUploadedDocument } = this.state;
        reasonData.reasonForDownload = result.data.reasonForDownload;
        reasonData.updatedDetails = result.data.updatedDetails;
        if (reasonData.updatedDetails && reasonData.updatedDetails.length > 0) {
          lastUploadedDocument = reasonData.updatedDetails[0].url[0];
        }
        this.setState({ updateDownloadData: reasonData, lastUploadedDocument });
      })
      .catch((err) => {
        console.log("Errororor", err);
        // ToastsStore.error("Failed to get ");
      });
  };
  blockdownload = () => {
    const fileId = this.props.match.params.id;
    callApi("POST", "block_download_status.php", {
      file_idfk: fileId,
    })
      .then((res) => res.data)
      .then((response) => {
        this.setState({
          blockdownload: response["responseJson"].data[0].block_download_status,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getFiles = () => {
    const fileId = this.props.match.params.id;

    // Fetch minimal file details (status/opinion + fallback template id)
    callApi("POST", "search.php", {
      file_name: fileId,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response["data"] && response["data"][0]) {
          const filestatus = response["data"][0].file_status;
          const fileOpinionType = response["data"][0].opinion_type;
          const bankTempId = response["data"][0].bank_temp_id;

          this.setState((prev: any) => ({
            filestatus,
            fileOpinionType,
            // fallback: preselect bank template if API provides it
            bank_id: prev.bank_id || bankTempId || prev.bank_id,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });

    // Fetch canonical dashboard info (org_bank_id / productId / lawhands_branch / bank_id(template))
    // This mirrors `src/components/work-file/index.tsx` and ensures ids are correct.
    callApi("POST", "file_dash.php", {
      branch_idfk: fileId,
    })
      .then((res) => res.data)
      .then((response) => {
        const dashInfo = response?.info?.[0];
        if (dashInfo) {
          this.setState((prev: any) => ({
            info: {
              ...prev.info,
              ...dashInfo,
            },
            // keep any user-selected template; otherwise use server-provided template id
            bank_id: prev.bank_id || dashInfo.bank_id || prev.bank_id,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getBank = () => {
    callApi("POST", "bank_get.php").then((response) => {
      console.log(response);
      this.setState(
        {
          bank: response.data.data,
          selectedBank: response.data.data[0].id,
        },
        () => {
          this.getBankBranch();
        },
      );
    });
  };
  getBankBranches() {
    callApi("GET", "bank_branch_get.php")
      .then((res) => res.data)
      .then((result) => {
        this.setState({ branches: result.data, filteredBranches: [] });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  getFormData = () => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const fileId = this.props.match.params.id;
    callApi("POST", "get_verification_checklist.php", {
      fileNo: fileId,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.responseJson.data.currentJson) {
          this.setState({
            data: JSON.parse(response.responseJson.data.currentJson),
            verificationEOD:
              response.responseJson.data.eod_submit == true ? true : false,
          });
        } else {
          this.setState({ data: DataModel });
          this.getVerificationListData();
        }
      })
      .catch((err) => {
        this.setState({ data: DataModel });
        this.getVerificationListData();
      });
  };

  getVerificationListData = () => {
    const fileId = this.props.match.params.id;
    callApi("POST", "get_verification.php", {
      fileNo: fileId,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response && response.data) {
          let modifiedData = { ...this.state.data };
          Object.entries(response.data).forEach((data: any) => {
            if (data[0] && data[1]) {
              modifiedData = {
                ...modifiedData,
                [data[0]]: {
                  ...modifiedData[data[0]],
                  ...data[1],
                },
              };
            }
          });
          this.setState({
            data: modifiedData,
          });
        } else {
          this.setState({ data: DataModel });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getBankBranch = () => {
    callApi("POST", "verify_branch_get.php", {
      id: this.state.selectedBank,
    }).then((response) => {
      if (response.data.status == 200) {
        const data = response.data.responseJson.dataList;

        this.setState({
          bankBranch: data,
        });
      }
    });
  };

  getValueFromList = (array, filterValue) => {
    let result = null,
      currentValue: any = [];
    if (filterValue) {
      currentValue = array.filter((val: any) => val.id === filterValue);
      if (currentValue.length > 0) {
        result = currentValue[0].value;
      }
    }
    return result;
  };
  getFormFieldValues = () => {
    callApi("POST", "verify_get.php", {
      file_id: this.props.match.params.id,
    }).then((response) => {
      if (response.data && response.data.result) {
        let {
          selectedBank,
          selectedBranch,
          selectedLawBranch,
          branches,
          bankBranch,
          bank,
          lawHandBranch,
          date,
          notes,
          inEcFinalNotes,
        } = this.state;
        const responseData = response.data.data[0];
        selectedBank = this.getValueFromList(bank, responseData.bank_id) || "";
        // selectedBranch = this.getValueFromList(bankBranch, responseData.branch_id) || "";
        selectedBranch =
          this.getValueFromList(branches, responseData.branch_id) || "";
        selectedLawBranch =
          this.getValueFromList(
            lawHandBranch,
            responseData.law_hand_branch_id,
          ) || "";
        inEcFinalNotes = responseData.in_ec_final || "";
        date = responseData.date || "";
        notes = responseData.cretificate_notes || "";
        this.setState({
          selectedBank,
          selectedBranch,
          selectedLawBranch,
          date,
          notes,
          inEcFinalNotes,
        });
        this.filterBranches(responseData.bank_id);
        console.log("this.state---", this.state);
      }
    });
  };

  filterBranches = (bankid) => {
    const filteredBranches = this.state.branches.filter(
      (branch: any) => branch.bank_id === bankid,
    );
    const state = this.state;
    state.branches = filteredBranches;
    this.setState({ ...state });
  };
  getLawHandsBranches = () => {
    callApi("GET", "get_branch.php")
      .then((res) => res.data)
      .then((response) => {
        this.setState({ lawHandBranch: response.data }, () => {
          this.getFormFieldValues();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getDocList = () => {
    const props: any = this.props;
    callApi("POST", "doc_list_get.php", { id: props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        console.log(response);
        if (response.data && response.data.length) {
          const titleDeed = _.filter(response.data, ["type", "Title Deed"])[0];
          console.log(titleDeed);
          this.setState({ docList: titleDeed.documents });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getScrutinizedDocs = () => {
    callApi("POST", "doc_scrutinize_list.php", {
      id: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((response) => {
        console.log(response);
        const scr = response.data.filter((itm) => itm.type === "scrutiny");
        const ec = response.data.filter((itm) => itm.type === "ec-form");
        if (scr && scr.length) {
          scr.forEach((doc, index) => {
            doc.index = index + 1;
          });
        }
        if (ec && ec.length) {
          ec.forEach((doc, index) => {
            doc.index = index + 1;
          });
        }
        const scrutinies = scr.concat(ec);
        this.setState({ scrutinyList: scrutinies });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getTracingHistory = () => {
    callApi("POST", "api_history_json.php", {
      id: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.result) {
          const data = response.history_possession_datas;
          this.setState({
            hasTracingHistory: data.history,
            hasTracingPossession: data.possession,
            hasTracingSaleAgreement: data.sale_agreement,
            hasThereSuch: response.title_final_json.rendered_text,
            hasInfinal: response.encumbrance_final_json?.rendered_text,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching tracing history:", err);
      });
  };

  getReportParagraphEC = () => {
    callApi("POST", "checklist_tracing_ec.php", {
      id: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.success) {
          const checklist_tracing_ec = response.ec_new || [];
          // Handle both string and object cases
          let ec_title_text = "";

          if (typeof response.ec_title_text === "string") {
            ec_title_text = response.ec_title_text;
          } else if (
            response.ec_title_text &&
            typeof response.ec_title_text === "object"
          ) {
            // If it's an object, try to extract a string value
            ec_title_text =
              response.ec_title_text.value ||
              response.ec_title_text.text ||
              JSON.stringify(response.ec_title_text);
          }
          this.setState({
            checklist_tracing_ec,
            ec_title_text,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getGeneralDetail = () => {
    const fileId = this.props.match.params.id;

    callApi("POST", "discription_property_get.php", {
      fod_fk: fileId,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.data) {
          const schedulesList = response.data.schedules;
          if (schedulesList && schedulesList?.[0]?.nature_doc != "") {
            this.setState({ schedulesList });
          } else {
            this.setState({ schedulesList: [] });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getFileDetails() {
    callApi("POST", "check_file_approval_status.php", {
      file_id: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.result) {
          this.setState({
            final_approval_taken_status:
              response.info.final_approval_taken_status,
            final_approval_status: response.info.final_approval_status,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getPreDisbursal() {
    callApi("POST", "pre_disbursal_get.php", {
      file_id: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((result) => {
        if (result.data && result.data.length) {
          this.setState({ pre_disbursal_list: result.data });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getPostDisbursal() {
    callApi("POST", "post_disbursal_get.php", {
      file_id: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((result) => {
        if (result.data && result.data.length) {
          this.setState({ post_disbursal_list: result.data });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  getFileOverview = () => {
    const props: any = this.props;
    callApi("POST", "final_report_get.php", {
      file_idfk: props.match.params.id,
      check: true,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response && response.data && response.data.length) {
          if (response.data[0].rep_id) {
            const state = response.data[0];
            this.setState({ ...state, isMainFrameLoading: false });
          } else {
            const props: any = this.props;
            const user: any = localStorage.getItem("user");
            const userId = user ? JSON.parse(user)["userId"] : "";
            callApi("POST", "template/tests/scrutiny_report.php", {
              file_idfk: props.match.params.id,
              check: true,
              userId,
            })
              .then((res) => res.data)
              .then((response) => {
                this.setState({ report: "" });
                this.setState({
                  report: response.data,
                  isMainFrameLoading: false,
                });
              })
              .catch(() => {
                this.setState({ isMainFrameLoading: false });
              });
          }
          this.setState({ isapproved: response.data[0].isapproved });
        } else this.setState({ isMainFrameLoading: false });
      })
      .catch(() => {
        this.setState({ isMainFrameLoading: false });
      });
  };
  getFileQA = () => {
    const props: any = this.props;
    const obj = {
      file_id: props.match.params.id,
    };
    callApi("POST", "file_question_answer_get.php", obj)
      .then((res) => res.data)
      .then((response) => {
        let resData = response.responseJson.data;
        // resData = _.sortBy(resData, (o) => {
        //     return Number(o.id);
        // });
        this.setState({ qaList: resData });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  handleChange = (name, e) => {
    this.setState({ [name]: e.value, isEdited: true }, () => {
      if (name === "selectedBank") {
        this.getBankBranch();
      }
    });
  };
  handleTemplateChange = (selectedOption: any) => {
    if (!selectedOption) return;

    // Check if user has made any changes
    const hasChanges =
      this.state.isEdited ||
      this.state.qaList.some((qa: any) => qa.answer && qa.answer.trim() !== "");

    if (hasChanges) {
      // Show confirmation modal
      this.setState({
        showConfirmModal: true,
        selectedTemplate: selectedOption,
      });
    } else {
      // No changes, proceed directly
      this.setState(
        {
          bank_id: selectedOption.value,
          isIframeLoading: true,
          overviewReport: "",
          timer: 0,
          isEdited: false,
          templateChangedSinceLastSave: true,
        },
        () => {
          // Save the template immediately when changed
          this.saveTemplate(selectedOption.value);
        },
      );
    }
  };
  handleqaChange = (e, i) => {
    const { qaList } = this.state;
    const list: any = qaList;
    list[i].answer = e.target.value;
    this.setState({ qaList: list, isEdited: true });
  };
  handleLodChange = (modData) => {
    const { data } = this.state;
    data.missingLOD = modData;
    this.setState({ data });
  };
  questionHandleChange = (e, i) => {
    const list: any[] = this.state.qaList;
    list[i]["question"] = e;
    this.setState({
      isEdited: true,
      qaList: list,
    });
  };
  getFile = (id, docType) => {
    // Save scroll position before showing document
    if (this.qaContainerRef.current) {
      const scrollTop = this.qaContainerRef.current.scrollTop;
      this.setState({ scrollPosition: scrollTop });
    }

    this.setState({ document: "", currentFileType: docType });
    this.setState({ isDocShow: true, currentFileId: id, fileFrameId: 1 });

    callApi("POST", "getbaseby_id.php", { id })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          const document = response.data[0].base[0].base;
          this.setState({ document, fileFrameId: !this.state.fileFrameId });
        }
        this.setState({ isSideFrameLoading: false });
        this.getHighlights(id, docType);
      })
      .catch((err) => {
        this.setState({ isSideFrameLoading: false });
        console.log(err);
      });
  };
  getHighlights = (id, docType) => {
    this.setState({ isDocShow: true, currentFileId: id, fileFrameId: 1 });
    callApi("POST", "get_highlight.php", { scrutiny_id: id, docType })
      .then((res) => res.data)
      .then((response) => {
        if (response) {
          const highlights = response.highlights || [];
          this.setState({
            highlights,
            isHightlightsLoaded: true,
          });
        }
      })
      .catch((err) => {
        this.setState({ isHightlightsLoaded: false });
        console.log(err);
      });
  };
  saveQADetails = (action: any) => {
    this.setState({ isSubmitting: true, isSaving: true });
    const {
      selectedBank,
      selectedBranch,
      selectedLawBranch,
      notes,
      date,
      inEcFinalNotes,
    } = this.state;
    const obj = {
      file_id: this.props.match.params.id,
      bank_id: selectedBank,
      in_ec_final: inEcFinalNotes,
      branch_id: selectedBranch,
      date: date,
      law_hand_branch_id: selectedLawBranch,
      cretificate_notes: notes,
    };
    console.log(obj);
    callApi("POST", "verify_update.php", obj)
      .then((res) => res)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          // ToastsStore.success("Saved succesfully");
          this.setState({ isSubmitting: false, isSaving: false });
        } else {
          ToastsStore.error("Error in storing, Please try again!");
          this.setState({ isSubmitting: false, isSaving: false });
        }
      })
      .catch((err) => {
        this.setState({ isSubmitting: false, isSaving: false });
        console.log(err);
      });
    this.saveQA(action);
    this.saveVerification();
  };
  saveQA = (action: any) => {
    const props: any = this.props;
    const obj = {
      file_id: props.match.params.id,
      answers: this.state.qaList,
    };
    console.log(obj);

    callApi("POST", "answer_add.php", [obj])
      .then((res) => res)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          if (action === "submit") {
            this.setState({ isSubmitting: false, isSaving: false });

            const finalapprove = localStorage.getItem(
              "finalapprovalprocesscheck",
            );
            const parsedfinallapprove = finalapprove
              ? JSON.parse(finalapprove)
              : null;
            const previousStep = parsedfinallapprove?.previousStep || "";
            const fromCheckPage = parsedfinallapprove?.fromCheckPage;
            if (fromCheckPage) {
              // Navigate back to WorkFile with the step in state
              this.props.history.push({
                pathname: `/work-file/7/${this.props.match.params.id}`, // Keep the URL as is
                state: {
                  previousStep: previousStep,
                  fromCheckPage: fromCheckPage,
                },
              });
              // localStorage.removeItem("finalapprovalprocesscheck");
            } else {
              this.props.history.goBack();
            }
          } else if (action === "save") {
            this.setState(
              {
                mainFrameId: !this.state.mainFrameId,
                isMainFrameLoading: true,
                overviewReport: "",
                timer: 0,
                isshowsavsubmit: true,
              },
              () => {
                this.scrutinyReport();
              },
            );
          }
          ToastsStore.success("Changes saved successfully");
          this.setState({
            isSubmitting: false,
            isSaving: false,
            isEdited: false,
            templateChangedSinceLastSave: false,
          });
        } else {
          ToastsStore.error("Error in storing, Please try again!");
          this.setState({ isSubmitting: false, isSaving: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isSubmitting: false, isSaving: false });
      });
  };
  saveVerification = () => {
    const { data } = this.state;
    const props: any = this.props;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    if (!data.remarks) {
      ToastsStore.error("Enter Remarks!");
    } else {
      const obj = {
        fileNo: props.match.params.id,
        currentData: data,
        oldData: data,
        loginId: userId,
      };
      callApi("POST", "verification_checklist.php", obj)
        .then((res) => res.data)
        .then((response) => {
          // ToastsStore.success("verification checklist saved");
          this.setState({ isSubmitting: false, isSaving: false });
        });
    }
  };
  confirmCompleteFinalApproval = () => {
    if (this.state.isFinalApprovalLoading) {
      return;
    }

    if (this.state.isComplete) {
      this.uploadDoc();
    }
    // First check if error locations are selected
    if (
      !this.state.selectedErrorLocations ||
      this.state.selectedErrorLocations.length === 0 ||
      this.state.errorDetails == ""
    ) {
      ToastsStore.error(
        "Please select at least one error location before final approval",
      );
      return;
    }

    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const fileId = this.props.match?.params?.id;
    if (!fileId || fileId === "null") {
      ToastsStore.error("Invalid file id. Please refresh and try again.");
      return;
    }

    this.setState({ isFinalApprovalLoading: true });
    // Extract only the values and join them as comma-separated string
    const errorLocationValues = this.state.selectedErrorLocations.map(
      (location: any) => location.value,
    );
    const checklistWithErrors = {
      ...this.state.checklist,
      errorLocations: errorLocationValues,
      errorDetails: this.state.errorDetails,
    };

    callApi("POST", "final_approval_complete.php", {
      file_id: fileId,
      user_id: userId,
      checkList: checklistWithErrors,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.result === true) {
          ToastsStore.success(response.message);
          this.setState({ isFinalApprovalLoading: false });
          $("#final-approval-model").modal("hide");
          this.previousPage();
          ToastsStore.success("Final Approval Completed Successfully");
        } else {
          ToastsStore.error(response.message);
          this.setState({ isFinalApprovalLoading: false });
        }
      })
      .catch((err) => {
        this.setState({ isFinalApprovalLoading: false });
        console.log(err);
      });
  };

  previousPage = (type?: any) => {
    const fileurl: any = localStorage.getItem("url");
    localStorage.removeItem("thisPopup");
    localStorage.removeItem("isPopupFromWIP");
    localStorage.removeItem("url");
    localStorage.setItem("filedashboardback", "true");
    localStorage.removeItem("currentfileId");
    localStorage.removeItem("BankTemplate");
    this.props.history.push(`${fileurl}`);
  };

  handleChecklistGroupChange = (group, index) => {
    const updatedGroup = [...this.state.checklist[group]];
    updatedGroup[index].checked = !updatedGroup[index].checked;

    this.setState({
      checklist: {
        ...this.state.checklist,
        [group]: updatedGroup,
      },
    });
  };

  changeHandler = (stateName, value) => {
    this.setState({ [stateName]: value });
  };
  actionHandle = (action) => {
    this.setState({ action });
  };
  handleReasonChange = (e) => {
    this.setState({ reason: e.target.value });
  };
  setVerify = (verify) => {
    this.setState({ verification: verify });
  };
  validateReason = () => {
    if (this.state.reason === "") {
      ToastsStore.error("Please Enter Reason");
    } else {
      if (this.state.action === "download") {
        this.downloadDoc();
      } else {
        $("#reason-modal").modal("hide");
        this.uploadDoc();
        // $("#verification-modal").modal("show");
      }
    }
  };
  downloadDoc = () => {
    $("#reason-modal").modal("hide");
    const props: any = this.props;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const obj = {
      fileid: props.match.params.id,
      reason: this.state.reason,
      createdBy: userId,
    };
    callApi("POST", "download_log.php", obj)
      .then((res) => res)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          // ToastsStore.success("work file Q & A are saved succesfully")
          ToastsStore.success("Reason saved successfully");
          this.downloadDocs();
          this.clearModal();
        } else {
          ToastsStore.error("Error in storing, Please try again!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  //Download docs from external api
  downloadDocs = () => {
    const { lastUploadedDocument } = this.state;
    if (lastUploadedDocument.docx) {
      callApi("POST", "get_branch_code.php", {
        id: this.props.match.params.id,
      })
        .then((res) => res.data)
        .then((response) => {
          const name = `${response.data[0].lawhands_branch}-${this.props.match.params.id}.docx`;
          saveAs(lastUploadedDocument.docx, name);
        });
    } else {
      const props: any = this.props;
      // ToastsStore.success("Downloaded Successful!");
      callApi("POST", "template/tests/shell.php", {
        id: props.match.params.id,
        responseType: "blob",
      })
        .then((res) => res.data)
        .then((response) => {
          //ToastsStore.success("Downloaded Successfully!");
          window.open(
            API_ENDPOINT +
            "template/tests/shell.php?id=" +
            props.match.params.id,
            "_self",
          );
        });
    }
  };
  uploadDoc = () => {
    const props: any = this.props;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const serverLocalFileName = localStorage.getItem("serverLocalFileName");

    const obj: any = { ...this.state.verification };
    obj.fileId = props.match.params.id;
    obj.reason =
      this.state.blockdownload === "true" && this.state.fileOpinionType == "1"
        ? "Final Approval Completed"
        : this.state.reason;
    obj.serverLocalFileName =
      this.state.blockdownload === "true" && this.state.fileOpinionType == "1"
        ? this.state.serverLocalFileName || serverLocalFileName
        : "";
    obj.file = this.state.uploadFile.base64.split(",")[1];
    obj.createdBy = userId;
    const errorTypes: any = [];
    obj.errorTypes.forEach((type: any) => {
      errorTypes.push({ type });
    });
    obj.errorTypes = errorTypes.length > 0 ? errorTypes : ["1", "2"];
    obj.errorSection = ["1", "2"];
    callApi("POST", "template/tests/upload_log.php", obj)
      .then((res) => res)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          $("#verification-modal").modal("hide");
          this.setState({ isComplete: false }, () => {
            if (
              this.state.blockdownload == "true" &&
              this.state.fileOpinionType == "1"
            ) {
              this.confirmCompleteFinalApproval();
            } else {
              ToastsStore.success("Reason saved successfully");
            }
          });
          this.clearModal();
        } else {
          ToastsStore.error("Error in storing, Please try again!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  uploadFile = (file: any) => {
    this.setState({ uploadFile: file });
  };
  clearModal = () => {
    const verification = {
      highlight: false,
      dataEntry: false,
      flowChart: false,
      hintFile: false,
      errorIdentified: false,
      noOflod: "",
      errorSection: [],
      otherSection: "",
      errorTypes: [],
      errorDetails: "",
      totalTime: "",
    };
    this.setState({
      reason: "",
      verification,
    });
  };
  updatedRemainingTime(time) { }
  incrementTimer = () => {
    if (this.state.generationTimedOut || this.state.overviewReport) {
      return;
    }
    this.setState(
      (prevState: any) => ({
        timer: prevState.timer + 1,
      }),
      () => {
        if (
          this.state.timer >= DOC_GEN_TIMEOUT_SEC &&
          !this.state.generationTimedOut &&
          !this.state.overviewReport &&
          !this.generationTimeoutTriggered
        ) {
          failWithDocGenTimeout((message) =>
            this.handleGenerationFailure(message),
          );
        }
      },
    );
  };
  handleErrorLocationChange = (selectedOptions: any) => {
    this.setState({
      selectedErrorLocations: selectedOptions || [],
    });
  };
  handleErrorDetailsChange = (e) => {
    this.setState({
      errorDetails: e.target.value,
    });
  };
  scrutinyReport = () => {
    if (this.state.generationTimedOut || this.generationTimeoutTriggered) {
      this.stopPollingAndTimer();
      return;
    }
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    this.setState({ isIframeLoading: true, timer: 0 });
    callApi("POST", "template/tests/scrutiny_report_zmq.php", {
      file_idfk: this.props.match.params.id,
      check: false,
      userId,
    })
      .then((res) => res.data)
      .then((response) => {
        if (isDocGenFailedResponse(response)) {
          this.handleGenerationFailure(docGenFailureMessage(response));
          return;
        }
        if (isDocGenQueued(response)) {
          localStorage.setItem("serverLocalFileName", response.local_file_name);
          this.setState({ serverLocalFileName: response.local_file_name });
          this.finalReport(response);
          return;
        }
        this.handleGenerationFailure(
          docGenFailureMessage(
            response,
            "Word document generation service is unreachable. Please contact the Support Team",
          ),
        );
      })
      .catch((err) => {
        console.log(err);
        this.handleGenerationFailure(extractAxiosDocGenError(err));
      });
  };

  finalReport = (zmqresponse) => {
    pollGeneratedDocx({
      url: zmqresponse.doc_path,
      isCancelled: () =>
        this.state.generationTimedOut || this.generationTimeoutTriggered,
      onReady: () => {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
          this.timeoutId = null;
        }
        localStorage.setItem("overviewDocument", zmqresponse.data);
        var currentFile = zmqresponse.file_name.split("-");
        localStorage.setItem("currentFile", currentFile[1]);
        this.stopTimer();
        clearDocGenTimeout(this.props.match.params.id);
        this.setState({
          overviewReport: zmqresponse.data,
          isMainFrameLoading: false,
          isIframeLoading: false,
        });
        releaseDocGenClickFreeze();
      },
      onFailure: (message) => this.handleGenerationFailure(message),
      schedule: (fn, ms) => {
        this.timeoutId = setTimeout(fn, ms);
      },
    });
  };

  stopTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
  stopPollingAndTimer = () => {
    this.stopTimer();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  };
  handleGenerationFailure = (detail: string) => {
    this.stopPollingAndTimer();
    this.generationTimeoutTriggered = true;
    releaseDocGenClickFreeze();
    const error = (detail || "Document generation failed.").trim();
    writeDocGenTimeout(this.props.match.params.id, error);
    this.setState({
      generationTimedOut: true,
      generationError: error,
      isIframeLoading: false,
      isMainFrameLoading: false,
    });
  };
  retryDocumentGeneration = () => {
    clearDocGenTimeout(this.props.match.params.id);
    window.location.reload();
  };

  enableModalHandler = () => {
    // $("#complete-process").modal("show");
    if (
      this.state.blockdownload == "true" &&
      this.state.fileOpinionType == "1"
    ) {
      // this.completeModalHandler();
      if (this.state.isComplete) {
        $("#final-approval-model").modal("show");
        return;
      }
      if (this.state.filestatus != "5") {
        this.uploadDoc();
      } else {
        ToastsStore.error("Completed File can't be processed");
      }
    } else {
      $("#complete-process").modal("show");
    }
  };

  DescriptionOfProperty = (title: string) => {
    const { schedulesList } = this.state;
    const fileId = this.props.match.params.id;
    const history: any = this.props.history;

    if (!schedulesList || schedulesList.length === 0) return null;

    return (
      <tr>
        <td colSpan={2} style={{ padding: 0 }}>
          <div className="m-10 mb-10">
            <table className="table nowrap">
              <tbody>
                {schedulesList.map((schedule: any, schIdx: number) => {
                  const docNumbers = [
                    schedule.this_doc_no,
                    ...(schedule.title_doc_no || []),
                  ]
                    .filter(Boolean)
                    .join(", ");

                  return (
                    <>
                      {schedule.editorMode ? (
                        <>
                          <tr>
                            <td colSpan={4} style={{ textAlign: "center" }}>
                              <p style={{ margin: 0, fontWeight: "bold" }}>
                                As per Doc No : {docNumbers}
                              </p>
                            </td>
                            <td
                              className="text-center"
                              onClick={() => {
                                history.push({
                                  pathname: `/general-detail/1/${fileId}/${schedule.file_id}`,
                                  state: { hash: "Verify" },
                                });
                              }}
                            >
                              <img src={edit} alt="edit" />
                            </td>
                          </tr>
                          <tr>
                            <td
                              colSpan={4}
                              onClick={() =>
                                this.getFile(schedule.file_id, "sop")
                              }
                            >
                              <SunEditor
                                setContents={schedule.editorcontent || ""}
                                disable={false}
                                hideToolbar={true}
                                readOnly={true}
                                setOptions={{
                                  height: "auto",
                                  minHeight: "auto",
                                  maxHeight: "auto",
                                  resizingBar: false,
                                }}
                              />
                            </td>
                          </tr>
                        </>
                      ) : (
                        <>
                          <tr>
                            <td colSpan={4} style={{ textAlign: "center" }}>
                              <p style={{ margin: 0, fontWeight: "bold" }}>
                                As per Doc No : {docNumbers}
                              </p>
                            </td>
                            <td
                              className="text-center"
                              onClick={() => {
                                history.push({
                                  pathname: `/general-detail/1/${fileId}/${schedule.file_id}`,
                                  state: { hash: "Verify" },
                                });
                              }}
                            >
                              <img src={edit} alt="edit" />
                            </td>
                          </tr>

                          {schedule.survey_details.map(
                            (detail: any, detailIdx: number) => {
                              const boundaries = detail.boundary_details || [];

                              return (
                                <React.Fragment key={`${schIdx}-${detailIdx}`}>
                                  {/* i — Survey Details */}
                                  <tr
                                    className="query-table-row noBoxShadow"
                                    onClick={() =>
                                      this.getFile(schedule.file_id, "sop")
                                    }
                                  >
                                    <td className="text-align-center padding4">
                                      i
                                    </td>
                                    <td className="padding4">Survey Details</td>
                                    <td colSpan={2} className="padding4">
                                      S.No- {detail.survey_no}
                                    </td>
                                  </tr>

                                  {/* ii — Revenue Record */}
                                  <tr
                                    className="query-table-row noBoxShadow"
                                    onClick={() =>
                                      this.getFile(schedule.file_id, "sop")
                                    }
                                  >
                                    <td className="text-align-center padding4">
                                      ii
                                    </td>
                                    <td className="padding4">
                                      As per Revenue Record
                                    </td>
                                    <td colSpan={2} className="padding4">
                                      {detail.revenue_record || "-"}
                                    </td>
                                  </tr>

                                  {/* iii — Total Extent */}
                                  <tr
                                    className="query-table-row noBoxShadow"
                                    onClick={() =>
                                      this.getFile(schedule.file_id, "sop")
                                    }
                                  >
                                    <td className="text-align-center padding4">
                                      iii
                                    </td>
                                    <td className="padding4">Total Extent</td>
                                    <td colSpan={2} className="padding4">
                                      {detail.extent} {detail.sur_extent_unit}
                                    </td>
                                  </tr>

                                  {/* iv — Door No */}
                                  <tr
                                    className="query-table-row noBoxShadow"
                                    onClick={() =>
                                      this.getFile(schedule.file_id, "sop")
                                    }
                                  >
                                    <td className="text-align-center padding4">
                                      iv
                                    </td>
                                    <td className="padding4">
                                      Door No (As per property tax)
                                    </td>
                                    <td colSpan={2} className="padding4">
                                      {schedule.door_no || "-"}
                                    </td>
                                  </tr>

                                  {/* v — Location */}
                                  <tr
                                    className="query-table-row noBoxShadow"
                                    onClick={() =>
                                      this.getFile(schedule.file_id, "sop")
                                    }
                                  >
                                    <td className="text-align-center padding4">
                                      v
                                    </td>
                                    <td className="padding4">
                                      Location: Name of place, village,
                                      district, etc.
                                    </td>
                                    <td colSpan={2} className="padding4">
                                      {schedule.address}
                                    </td>
                                  </tr>

                                  {/* vi — Boundaries (i), ii), iii)... exactly like left side */}
                                  {boundaries.length > 0 && (
                                    <tr
                                      className="query-table-row noBoxShadow"
                                      onClick={() =>
                                        this.getFile(schedule.file_id, "sop")
                                      }
                                    >
                                      <td className="text-align-center padding4">
                                        vi
                                      </td>
                                      <td colSpan={3} className="padding4">
                                        {boundaries.map(
                                          (bound: any, bIdx: number) => {
                                            const romanNum =
                                              ["i", "ii", "iii", "iv", "v"][
                                              bIdx
                                              ] || `${bIdx + 1}`;
                                            const landArea =
                                              bound.land_aries ||
                                              bound.measurement ||
                                              "Land";
                                            const unit =
                                              bound.unit || bound.m_unit || "";
                                            const plotRef = bound.plot_item_no
                                              ? bound.boundaryNoType ===
                                                "Plot No"
                                                ? `Plot No-${bound.plot_item_no}`
                                                : `Item No-${bound.plot_item_no}`
                                              : "";

                                            return (
                                              <div
                                                key={bIdx}
                                                style={{
                                                  marginBottom:
                                                    bIdx < boundaries.length - 1
                                                      ? "20px"
                                                      : "0",
                                                }}
                                              >
                                                <strong>
                                                  {romanNum}) Boundaries for{" "}
                                                  {landArea} {unit} of land{" "}
                                                  {plotRef
                                                    ? `[${plotRef}]`
                                                    : ""}
                                                </strong>
                                                <br />
                                                <strong>North By</strong> –{" "}
                                                {bound.north} <br />
                                                <strong>South By</strong> –{" "}
                                                {bound.south} <br />
                                                <strong>East By</strong> –{" "}
                                                {bound.east} <br />
                                                <strong>West By</strong> –{" "}
                                                {bound.west} <br />
                                                {/* Measurement Tables */}
                                                {bound.measurement_list &&
                                                  bound.measurement_list
                                                    .length > 0 && (
                                                    <>
                                                      {bound.measurement_list.map(
                                                        (
                                                          meas: any,
                                                          mIdx: number,
                                                        ) => (
                                                          <div
                                                            key={mIdx}
                                                            style={{
                                                              marginTop: "12px",
                                                            }}
                                                          >
                                                            <strong
                                                              style={{
                                                                display:
                                                                  "block",
                                                                textAlign:
                                                                  "center",
                                                                marginBottom:
                                                                  "5px",
                                                              }}
                                                            >
                                                              Measurement
                                                              Details{" "}
                                                              {meas.plot_item_no
                                                                ? `[Plot No- ${meas.plot_item_no}]`
                                                                : ""}
                                                            </strong>

                                                            <table
                                                              style={{
                                                                width: "60%",
                                                                margin:
                                                                  "8px auto",
                                                                borderCollapse:
                                                                  "collapse",
                                                                border:
                                                                  "1px solid #ccc",
                                                              }}
                                                            >
                                                              <tbody>
                                                                {meas.meas_dir_list?.map(
                                                                  (
                                                                    dir: any,
                                                                    dirIdx: number,
                                                                  ) => (
                                                                    <tr
                                                                      key={
                                                                        dirIdx
                                                                      }
                                                                    >
                                                                      <td
                                                                        style={{
                                                                          border:
                                                                            "1px solid #ddd",
                                                                          padding:
                                                                            "6px",
                                                                          textAlign:
                                                                            "center",
                                                                          backgroundColor:
                                                                            "#f9f9f9",
                                                                          width:
                                                                            "50%",
                                                                        }}
                                                                      >
                                                                        {dir.label_name ||
                                                                          ""}
                                                                      </td>
                                                                      <td
                                                                        style={{
                                                                          border:
                                                                            "1px solid #ddd",
                                                                          padding:
                                                                            "6px",
                                                                          textAlign:
                                                                            "center",
                                                                        }}
                                                                      >
                                                                        {
                                                                          dir.value
                                                                        }{" "}
                                                                        {meas.l_unit ||
                                                                          ""}
                                                                      </td>
                                                                    </tr>
                                                                  ),
                                                                )}
                                                                {meas.measurement && (
                                                                  <tr>
                                                                    <td
                                                                      style={{
                                                                        border:
                                                                          "1px solid #ddd",
                                                                        padding:
                                                                          "6px",
                                                                        fontWeight:
                                                                          "bold",
                                                                        backgroundColor:
                                                                          "#f0f0f0",
                                                                        textAlign:
                                                                          "center",
                                                                      }}
                                                                    >
                                                                      Total
                                                                    </td>
                                                                    <td
                                                                      style={{
                                                                        border:
                                                                          "1px solid #ddd",
                                                                        padding:
                                                                          "6px",
                                                                        fontWeight:
                                                                          "bold",
                                                                        textAlign:
                                                                          "center",
                                                                      }}
                                                                    >
                                                                      {
                                                                        meas.measurement
                                                                      }{" "}
                                                                      {meas.m_unit ||
                                                                        meas.l_unit}
                                                                    </td>
                                                                  </tr>
                                                                )}
                                                              </tbody>
                                                            </table>

                                                            {/* <div style={{ marginTop: "8px", fontStyle: "italic", color: "#555" }}>
                                                                                                            With all easement rights & pathway
                                                                                                        </div> */}
                                                          </div>
                                                        ),
                                                      )}
                                                    </>
                                                  )}
                                              </div>
                                            );
                                          },
                                        )}
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              );
                            },
                          )}
                        </>
                      )}
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    );
  };

  ListOfDocuments = (title, type) => {
    const scrutinyList = this.state.scrutinyList;
    const fileId = this.props.match.params.id;
    const history: any = this.props.history;

    return (
      <tr>
        <td colSpan={2}>
          <div className="mt-10">
            <div>
              <table className="table nowrap">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Dt & D.No</th>
                    <th>Particulars</th>
                    <th>Nature of Doc</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {scrutinyList?.map((item: any, i) => (
                    <tr key={i} style={{ background: item.color }}>
                      <td onClick={() => this.getFile(item.fod_fk, item.type)}>
                        {i + 1}
                      </td>
                      <td onClick={() => this.getFile(item.fod_fk, item.type)}>
                        {item.date}
                        <br />
                        {item.type == "scrutiny" ? item.doc_no : ""}
                      </td>
                      <td onClick={() => this.getFile(item.fod_fk, item.type)}>
                        {item.type == "ec-form" && item.ec_no != ""
                          ? item.doc_no
                          : item.type == "ec-form" && item.ec_no == ""
                            ? "Ec "
                            : ""}
                        {item.particulars}
                      </td>
                      <td onClick={() => this.getFile(item.fod_fk, item.type)}>
                        {type == "scrutiny"
                          ? `${item.nature_doc ? item.nature_doc : ""}`
                          : `${item.type == "ec-form"
                            ? item.nature_doc
                            : item.obtined
                          }`}
                      </td>
                      <td
                        className="text-center"
                        onClick={() => {
                          history.push({
                            pathname: `/${item.type}/${fileId}/${item.fod_fk}/2`,
                            state: { hash: "Verify" },
                          });
                        }}
                      >
                        <img src={edit} alt="edit" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </td>
      </tr>
    );
  };

  QARow = ({
    qa,
    index,
    currentIndex,
    setCurrentIndex,
    handleqaChange,
    questionHandleChange,
  }) => {
    return (
      <tr key={qa.id} className="check-list">
        {/* Question */}
        <td style={{ borderRight: "1px solid #dee2e6", padding: "0" }}>
          <SunEditor
            defaultValue={qa.question}
            height="100"
            name="question"
            setOptions={{
              height: "auto",
              minHeight: "auto",
              resizingBar: false,
            }}
            disable={true}
            hideToolbar={true}
            readOnly={true}
            setDefaultStyle="font-family: 'BookmanOldStyle'; font-size: 12px;"
            onChange={(e) => questionHandleChange(e, index)}
          />
        </td>

        {/* Answer */}
        <td style={{ width: "50%", border: "2px solid #dee2e6" }}>
          <textarea
            className="form-control"
            value={qa.answer}
            readOnly={qa.is_editable === 0}
            onFocus={(e) => {
              setCurrentIndex(index);
              e.target.select();
            }}
            onChange={(e: any) => {
              handleqaChange(e, index);
              // Auto expand
              e.target.style.height = "auto";
              e.target.style.height = e.target.scrollHeight + "px";
            }}
            rows={3}
          />

          {qa.is_editable === 0 ? (
            <p
              style={{
                fontSize: "10px",
                color: "#dc3545",
                marginTop: "3px",
              }}
            >
              Auto filled from {qa.field_lable || "master field"} - Field not
              editable
            </p>
          ) : (
            currentIndex === index && (
              <p
                id={`textarea_${index}`}
                style={{
                  fontSize: "10px",
                  color: "grey",
                  marginTop: "3px",
                }}
              >
                Maximum 250 characters
              </p>
            )
          )}
        </td>
      </tr>
    );
  };

  ECinFinal = (title) => {
    // const { inEcFinalNotes } = this.state;
    const fileId = this.props.match.params.id;
    const history: any = this.props.history;

    return (
      <>
        <tr>
          <td colSpan={2}>
            <div
              style={{
                backgroundColor: "white",
                padding: "15px",
                marginBottom: "5px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              }}
            >
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    flex: 1,
                    cursor: "pointer",
                    padding: "8px 0",
                  }}
                  dangerouslySetInnerHTML={{ __html: this.state.hasInfinal }}
                />
                <div
                  onClick={() => {
                    history.push({
                      pathname: `/work-file/6/${fileId}`,
                      state: { hash: "checkList" },
                    });
                  }}
                >
                  <img src={edit} alt="edit" />
                </div>
              </div>
            </div>
          </td>
        </tr>
      </>
    );
  };

  ReportParagraph = (items: any[], sectionTitle: string) => {
    if (!items || items.length === 0) {
      return (
        <tr>
          <td colSpan={2}>
            <div className="text-center py-8 text-gray-500">
              No {sectionTitle.toLowerCase()} data available
            </div>
          </td>
        </tr>
      );
    }

    return (
      <tr>
        <td colSpan={2} style={{ padding: 0, border: "none" }}>
          <div
            style={{
              backgroundColor: "white",
              padding: "15px",
              marginBottom: "5px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <div
              style={{
                textAlign: "justify",
                fontSize: "16px",
                lineHeight: "1.7",
                color: "#2d2d2d",
              }}
            >
              {items.map((item: any, index: number) => (
                <div
                  key={item.position + "_" + index}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "15px",
                  }}
                >
                  {/* Main Content - Click to View Document */}
                  <div>
                    <div
                      style={{
                        flex: 1,
                        cursor: "pointer",
                        padding: "8px 0",
                        textIndent: "40px",
                      }}
                      onClick={() => this.getFile(item.fod_fk, "scrutiny")}
                      dangerouslySetInnerHTML={{
                        __html:
                          item.hidden == 1
                            ? item.note || ""
                            : item.rendered_text || "",
                      }}
                    />

                    {item.hidden == 0 && item.note != "" && (
                      <>
                        <div
                          style={{ display: "flex", alignItems: "baseline" }}
                        >
                          <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                            Note:
                          </p>
                          <div
                            style={{
                              flex: 1,
                              cursor: "pointer",
                              padding: "8px 0",
                            }}
                            onClick={() =>
                              this.getFile(item.fod_fk, "scrutiny")
                            }
                            dangerouslySetInnerHTML={{
                              __html: item.note || "",
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>

                  {/* Edit Icon */}
                  {item.fod_fk && (
                    <div
                      style={{ cursor: "pointer", paddingTop: "8px" }}
                      onClick={() => {
                        this.props.history.push({
                          pathname: `/scrutiny/${this.props.match.params.id}/${item.fod_fk}/2`,
                          state: { hash: "Verify" },
                        });
                      }}
                      title="Edit Document"
                    >
                      <img src={edit} alt="edit" width={22} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </td>
      </tr>
    );
  };

  ReportParagraphTracingEC = (title: string) => {
    const ec_new = this.state.checklist_tracing_ec || []; // adjust state key as per your actual state
    const ec_title_text = this.state.ec_title_text || ""; // get the formatted text from state
    const fileId = this.props.match.params.id;
    const history: any = this.props.history;

    if (!ec_new || ec_new.length === 0) {
      return (
        <tr>
          <td colSpan={2}>
            <div className="text-center py-8 text-gray-500">
              No EC tracing data available
            </div>
          </td>
        </tr>
      );
    }

    return (
      <tr>
        <td colSpan={2} style={{ padding: 0, border: "none" }}>
          <div
            style={{
              backgroundColor: "#f9f9fb",
              padding: "20px 20px",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                textAlign: "justify",
                fontSize: "16px",
                lineHeight: "1.6",
                color: "#1a1a1a",
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: ec_title_text }} />

              {ec_new.map((ec: any, ecIndex: number) => (
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <div key={ecIndex} style={{ marginBottom: "1.8em" }}>
                    {/* EC Header Line */}
                    <div
                      style={{
                        marginBottom: "0.8em",
                        fontWeight: 600,
                        textDecoration: "underline",
                      }}
                    >
                      {ec.title}
                    </div>

                    {/* Content Entries */}
                    {ec.content.map((item: any, idx: number) => {
                      const isRange = item.entry.includes("-");

                      return (
                        <div
                          key={idx}
                          style={{
                            marginTop: idx === 0 ? "0" : "0.4em",
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            gap: "10px",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            {/* Entry Number/Range */}
                            <span
                              style={{
                                display: "inline-block",
                                textDecoration: "underline",
                                fontWeight: "bold",
                                color: "#1a1a1a",
                              }}
                            >
                              {item.entry.padEnd(isRange ? 18 : 12)}
                            </span>

                            {/* Entry Text */}
                            <span
                              style={{
                                color: "black",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                ec.fod_fk && this.getFile(ec.fod_fk, "ec-form")
                              }
                              dangerouslySetInnerHTML={{
                                __html: item.text.replace(
                                  /(dated\s+[\d.]+?\s+as\s+.*?)(?=\s+dated|$)/gi,
                                  "<span>$1</span>",
                                ),
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {/* Edit Icon */}
                  {ec.fod_fk && (
                    <div
                      className="text-center cursor-pointer"
                      onClick={() => {
                        history.push({
                          pathname: `/ec-form/${fileId}/${ec.fod_fk}/2`,
                          state: { hash: "Verify" },
                        });
                      }}
                    >
                      <img src={edit} alt="edit" width={20} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </td>
      </tr>
    );
  };

  Remarks = (title) => {
    const { notes } = this.state;

    return (
      <>
        <tr>
          <td colSpan={4} style={{ width: "100vw" }}>
            <div className="mt-10">
              <textarea
                className="form-control"
                name="notes"
                value={notes}
                onChange={(e) => this.handleChange("notes", e.target)}
              ></textarea>
            </div>
          </td>
        </tr>
      </>
    );
  };

  ThereSuch = (title) => {
    const fileId = this.props.match.params.id;
    const history: any = this.props.history;

    return (
      <>
        <tr>
          <td colSpan={2}>
            <div
              style={{
                backgroundColor: "white",
                padding: "15px",
                marginBottom: "5px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              }}
            >
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    flex: 1,
                    cursor: "pointer",
                    padding: "8px 0",
                  }}
                  dangerouslySetInnerHTML={{ __html: this.state.hasThereSuch }}
                />
                <div
                  onClick={() => {
                    history.push({
                      pathname: `/work-file/6/${fileId}`,
                      state: { hash: "checkList" },
                    });
                  }}
                >
                  <img src={edit} alt="edit" />
                </div>
              </div>
            </div>
          </td>
        </tr>
      </>
    );
  };

  PrePostRow = (title, data, sno: any) => {
    const fileId = this.props.match.params.id;
    const history: any = this.props.history;

    return (
      <tr>
        <td colSpan={18}>
          <div className="mt-10">
            <div className="dt-responsive table-responsive">
              <table className="table nowrap" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th style={{ width: "5%" }}>S.No</th>
                    <th style={{ width: "25%" }}>Date & Document Number</th>
                    <th style={{ width: "35%" }} className="text-center">
                      Particular Deed
                    </th>
                    <th style={{ width: "30%" }} className="text-center">
                      Nature Deed
                    </th>
                    <th style={{ width: "5%" }} className="text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data && data.length > 0 ? (
                    data.map((item: any, i) => (
                      <tr key={i}>
                        <td>{sno + i + 1}</td>
                        <td>
                          {item.date}
                          <br />
                          {item.document_number}
                        </td>
                        <td className="text-center">{item.particular_deed}</td>
                        <td className="text-center">{item.nature_deed}</td>
                        <td
                          className="text-center cursor-pointer"
                          onClick={() => {
                            history.push({
                              pathname: `/work-file/6/${fileId}`,
                              state: { hash: "checkList" },
                            });
                          }}
                        >
                          <img src={edit} alt="edit" />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5} className="text-center text-muted">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </td>
      </tr>
    );
  };

  renderAccordionSection(title, content, index) {
    return (
      <tr>
        <td colSpan={2} style={{ padding: ".55rem 0rem" }}>
          <Accordion
            key={index}
            defaultActiveKey="0"
            className="m-0 p-0"
            style={{ width: "100%" }}
          >
            <Card className="m-0 p-0" style={{ width: "100%" }}>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="0"
                style={{
                  cursor: "pointer",
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <strong style={{ whiteSpace: "pre-wrap", lineHeight: 2 }}>
                  {title}
                </strong>
                <i
                  className="feather icon-chevron-down"
                  style={{ float: "right" }}
                ></i>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="0">
                <Card.Body style={{ whiteSpace: "pre-wrap", width: "100%" }}>
                  {content}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </td>
      </tr>
    );
  }
  getTemplates = () => {
    const { info, bank_id } = this.state;

    callApi("POST", "file_dash_temp.php")
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          // Store templates in state
          this.setState({ bank_templates: response.data });

          // Save to localStorage
          var bankTempName = response.data;
          localStorage.setItem("BankTemplate", JSON.stringify(bankTempName));

          // Filter templates based on user role and file info
          const user: any = localStorage.getItem("user");
          const role_label = user ? JSON.parse(user)["role_label"] : "";

          let filterTemp = response.data;

          // If not Admin/Super Admin, filter based on file info
          if (
            role_label !== "Admin" &&
            role_label !== "Super Admin" &&
            info.org_bank_id &&
            info.productId &&
            info.lawhands_branch
          ) {
            filterTemp = response.data.filter(
              (temp: any) =>
                temp?.bank_id === info.org_bank_id &&
                temp?.product_id === info.productId &&
                Array.isArray(temp?.lawhands_branch) &&
                temp.lawhands_branch.includes(info.lawhands_branch),
            );
          }

          // If we have filtered templates and bank_id is not set yet
          if (filterTemp.length > 0 && !bank_id) {
            // Try to find the template that matches the file's bank template id
            const fileTemplate = filterTemp.find(
              (temp: any) => temp.id === (info as any).bank_id,
            );

            const newBankId = fileTemplate ? fileTemplate.id : filterTemp[0].id;

            this.setState({ bank_id: newBankId }, () => {
              // Save template info to localStorage
              const selectedTemp = filterTemp.find(
                (t: any) => t.id === newBankId,
              );
              if (selectedTemp) {
                localStorage.setItem(
                  "bankTemplateName",
                  selectedTemp.name || "",
                );
                localStorage.setItem(
                  "bankTemplatemode",
                  selectedTemp.mode || "",
                );
              }

              // Trigger template save
              this.saveTemplate(newBankId);
            });
          } else if (bank_id) {
            // If bank_id is already set, just update localStorage
            const selectedTemp = response.data.find(
              (t: any) => t.id === bank_id,
            );
            if (selectedTemp) {
              localStorage.setItem("bankTemplateName", selectedTemp.name || "");
              localStorage.setItem("bankTemplatemode", selectedTemp.mode || "");
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  rotate = () => {
    let newRotation = this.state.rotation + 90;
    if (newRotation >= 360) {
      newRotation = -360;
    }
    this.setState({ rotation: newRotation });
  };

  /** Performs the actual back navigation (used after exit confirm or when no unsaved changes). */
  performBackNavigation = () => {
    const parsedfinallapprove = JSON.parse(
      localStorage.getItem("finalapprovalprocesscheck") || "null"
    );
    const verififinalapprove = localStorage.getItem("verififinalapprove");
    const fromCheckPage = parsedfinallapprove?.fromCheckPage;
    const previousStep = parsedfinallapprove?.previousStep || "";

    if (fromCheckPage) {
      this.props.history.push({
        pathname: `/work-file/7/${this.props.match.params.id}`,
        state: { previousStep, fromCheckPage },
      });
    } else if (verififinalapprove === "verififinalapprove") {
      this.props.history.push({
        pathname: `/work-file-verification-list/${this.props.match.params.id}`,
      });
    } else if (
      verififinalapprove !== "verififinalapprove" &&
      !parsedfinallapprove?.fromCheckPage
    ) {
      this.props.history.push({
        pathname: `/final-approval-inprogress`,
      });
    } else {
      this.props.history.goBack();
    }
  };

  handleBackClick = () => {
    const hasUnsavedChanges =
      this.state.isEdited ||
      this.state.showConfirmModal ||
      this.state.templateChangedSinceLastSave;

    if (hasUnsavedChanges) {
      this.setState({ showExitConfirmModal: true });
    } else {
      this.performBackNavigation();
    }
  };

  handleExitConfirm = (exit: boolean) => {
    if (!exit) {
      this.setState({
        showExitConfirmModal: false,
      });
      return;
    }
    this.setState(
      {
        showExitConfirmModal: false,
        showConfirmModal: false,
        selectedTemplate: null,
      },
      () => {
        this.performBackNavigation();
      }
    );
  };

  renderExitConfirmModal = () => {
    if (!this.state.showExitConfirmModal) return null;
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 10000,
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            width: "400px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          }}
        >
          <h5>Exit without saving?</h5>
          <p>
            The changes will not be retrieved. Are you sure you want to exit?
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            <button
              className="btn btn-secondary"
              onClick={() => this.handleExitConfirm(false)}
            >
              Cancel
            </button>
            <button
              className="btn btn-secondary"
              style={{ backgroundColor: "red", border: "none" }}
              onClick={() => this.handleExitConfirm(true)}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    );
  };

  renderConfirmModal = () => {
    if (!this.state.showConfirmModal) return null;

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            width: "400px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          }}
        >
          <h5>Confirm Template Change</h5>
          <p>
            Are you sure you want to change the template? This may reset unsaved
            changes.
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            <button
              className="btn btn-secondary"
              onClick={() =>
                this.setState({
                  showConfirmModal: false,
                  selectedTemplate: null,
                })
              }
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                const template: any = this.state.selectedTemplate;
                if (template && template.value) {
                  this.setState(
                    {
                      bank_id: template.value,
                      isIframeLoading: true,
                      overviewReport: "",
                      timer: 0,
                      showConfirmModal: false,
                      selectedTemplate: null,
                      isEdited: false,
                      templateChangedSinceLastSave: true,
                      qaList: [], // Clear existing Q&A
                    },
                    () => {
                      this.saveTemplate(template.value);
                      // Fetch new Q&A for the selected template
                      this.getFileQA();
                    },
                  );
                }
              }}
            >
              Yes, Change
            </button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      isComplete,
      report,
      date,
      qaList,
      isHightlightsLoaded,
      currentIndex,
      document,
      isDocShow,
      isMainFrameLoading,
      isSideFrameLoading,
      action,
      reason,
      verification,
      uploadFile,
      branches,
      data,
    } = this.state;
    let initialTimeInMinutes: any = localStorage.getItem(
      "updatedRemainingTime",
    );
    const { verifiedfile } = this.props.location.state || {};
    const takenfile_id: any = localStorage.getItem("takenfile_id");
    const verififinalapprove: any = localStorage.getItem("verififinalapprove");
    const finalapprove = localStorage.getItem("finalapprovalprocesscheck");
    const parsedfinallapprove = finalapprove ? JSON.parse(finalapprove) : null;
    const currentfile_Id: any = localStorage.getItem("currentfileId");
    const currentfile = JSON.parse(currentfile_Id);
    const iframeSourcesoftware = this.state.overviewReport ?? "";
    const user: any = localStorage.getItem("user");
    const role_label = user ? JSON.parse(user)["role_label"] : "";
    const filterTemp =
      role_label !== "Admin" && role_label !== "Super Admin"
        ? this.state.bank_templates.filter(
          (temp: any) =>
            temp?.bank_id === this.state?.info?.org_bank_id &&
            temp?.product_id === this.state?.info?.productId &&
            Array.isArray(temp?.lawhands_branch) &&
            temp.lawhands_branch.includes(this.state?.info?.lawhands_branch),
        )
        : this.state.bank_templates;

    const banktemplatesoption = filterTemp.map((opt: any) => ({
      ...opt,
      label: `${opt.name}-${opt.bank_name}-${opt.product_name}`,
      value: opt.id,
    }));

    // Find the current value
    let currentValue = null;
    if (this.state.bank_id && banktemplatesoption.length > 0) {
      currentValue = banktemplatesoption.find(
        (o: any) => o.value === this.state.bank_id,
      );
    }

    return (
      <div className="pcoded-content p-0" id="work-file-details">
        <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />
        <div className="pcoded-inner-content">
          <div className="main-body">
            <div className="page-wrapper">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card mb-0">
                    <div className="row">
                      <div className="col-md-12">
                        {initialTimeInMinutes &&
                          initialTimeInMinutes > 0 &&
                          this.state.final_approval_taken_status != "1" && (
                            <CountdownTimer
                              initialTime={initialTimeInMinutes}
                              updatedTime={(time) =>
                                this.updatedRemainingTime(time)
                              }
                              ref={(ref) => (this.countdownTimerRef = ref)}
                            />
                          )}
                      </div>
                      <br />
                    </div>
                    <div className="card-header policy-header">
                      <div className="float-left mt-3">
                        <h5>
                          {(this.state.final_approval_taken_status == "1" && verififinalapprove != "verififinalapprove" &&
                            !parsedfinallapprove?.fromCheckPage)
                            ? "Final Approval – Verification"
                            : (verififinalapprove == "verififinalapprove" ? "Work File Verification" : "Work File Process")}
                        </h5>
                      </div>
                      {this.state.final_approval_status != "1" &&
                        this.state.isshowsavsubmit &&
                        (verififinalapprove == "verififinalapprove" ||
                          parsedfinallapprove?.fromCheckPage) && (
                          <button
                            className="btn btn-success float-right mt-2"
                            onClick={() => this.saveQADetails("submit")}
                            disabled={
                              this.state.isSaving || this.state.isSubmitting
                            }
                          >
                            {this.state.isSubmitting ? (
                              <>
                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                Submitting...
                              </>
                            ) : (
                              "Save & Submit"
                            )}
                          </button>
                        )}
                      <button
                        className="btn btn-primary mt-2"
                        onClick={() => this.saveQADetails("save")}
                        disabled={
                          this.state.isSaving || this.state.isSubmitting
                        }
                      >
                        {this.state.isSaving ? (
                          <>
                            <i className="fa fa-spinner fa-spin mr-2"></i>
                            Saving...
                          </>
                        ) : (
                          "Save"
                        )}
                      </button>
                      <button
                        className="btn btn-primary  mt-2"
                        style={{ backgroundColor: "red", border: "none" }}
                        onClick={this.handleBackClick}
                      >
                        Back
                      </button>
                      {this.state.final_approval_status == "1" &&
                        this.state.final_approval_taken_status == "1" &&
                        (verififinalapprove != "verififinalapprove" &&
                          !parsedfinallapprove?.fromCheckPage) && (
                          <>
                            {isComplete && (
                              <button
                                onClick={this.enableModalHandler}
                                className="btn btn-success float-right mt-2"
                              >
                                Final Approval Complete
                              </button>
                            )}
                            {!isComplete && (
                              <button
                                data-toggle="modal"
                                data-target="#final-approval-model"
                                className="btn btn-success float-right mt-2"
                              >
                                Final Approval Complete
                              </button>
                            )}
                            {this.state.final_approval_status == "1" &&
                              this.state.final_approval_taken_status == "1" &&
                              (this.state.blockdownload == "false" ||
                                this.state.fileOpinionType != "1") &&
                              verififinalapprove != "verififinalapprove" &&
                              !parsedfinallapprove?.fromCheckPage && (
                                <>
                                  <button
                                    className="btn btn-outline-dark mt-2"
                                    onClick={() =>
                                      this.actionHandle("download")
                                    }
                                    data-toggle="modal"
                                    data-target="#reason-modal"
                                  >
                                    Download Doc
                                  </button>
                                  <button
                                    className="btn btn-outline-dark mt-2"
                                    onClick={() => this.actionHandle("upload")}
                                    data-toggle="modal"
                                    data-target="#reason-modal"
                                  >
                                    Upload Doc
                                  </button>
                                </>
                              )}
                          </>
                        )}

                      <div
                        className="template-select float-left mt-2"
                        style={{ width: "20em" }}
                      >
                        {this.state.info.org_bank_id &&
                          banktemplatesoption.length > 0 ? (
                          <Select
                            options={banktemplatesoption}
                            name="bank_id"
                            value={currentValue}
                            onChange={this.handleTemplateChange}
                            isSearchable={true}
                            placeholder="Select Template"
                          />
                        ) : (
                          <div className="text-muted small ">
                            Loading templates...
                          </div>
                        )}
                      </div>
                      {this.state.final_approval_status == "1" &&
                        this.state.final_approval_taken_status == "1" &&
                        verififinalapprove != "verififinalapprove" &&
                        !parsedfinallapprove?.fromCheckPage && (
                          <button
                            className="btn btn-danger float-left mt-2"
                            data-toggle="modal"
                            data-target="#holdModal"
                          >
                            Hold
                          </button>
                        )}
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div
                            className="form-document"
                            style={{
                              overflow: "hidden",
                              justifyContent: "center",
                              border: "1px solid rgb(222, 226, 230)",
                            }}
                          >
                            <Accordion className="mainAccordion m-0 p-0">
                              <Tabs
                                defaultActiveKey="documentKey"
                                style={{ padding: 0 }}
                              >
                                <Tab
                                  eventKey="documentKey"
                                  title="Document"
                                  className="m-0 p-0"
                                >
                                  <div>
                                    {iframeSourcesoftware &&
                                      !this.state.isIframeLoading ? (
                                      <div className="iframe-container">
                                        <iframe
                                          src={iframeSourcesoftware}
                                          width="99%"
                                          frameBorder="0"
                                        >
                                          This is an embedded Word document.
                                        </iframe>
                                        <div className="top-overlay"></div>
                                        <div className="bottom-overlay"></div>
                                      </div>
                                    ) : (
                                      <div className="text-center">
                                        {this.state.generationTimedOut ? (
                                          <>
                                            <h4 style={{ color: "#c0392b" }}>
                                              {this.state.generationError ||
                                                "Document generation failed."}
                                            </h4>
                                            {!isDocGenWorkerDownError(
                                              this.state.generationError,
                                            ) ? (
                                            <button
                                              type="button"
                                              className="btn btn-primary mt-2"
                                              onClick={this.retryDocumentGeneration}
                                            >
                                              Retry
                                            </button>
                                            ) : null}
                                          </>
                                        ) : (
                                          <>
                                        <h4>
                                          <span>
                                            {this.state.isIframeLoading
                                              ? "Generating document..."
                                              : "Loading..."}{" "}
                                            {this.state.timer} seconds
                                          </span>
                                        </h4>
                                        <div
                                          className="spinner-border text-primary mt-3"
                                          role="status"
                                        >
                                          <span className="sr-only">
                                            Loading...
                                          </span>
                                        </div>
                                          </>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </Tab>
                                <Tab
                                  eventKey="hintKey"
                                  title="Hint About"
                                  className="m-0 p-0"
                                >
                                  <HintAboutFile
                                    id={this.props.match.params.id}
                                    path="workfileQA"
                                  />
                                </Tab>
                              </Tabs>
                            </Accordion>
                          </div>
                        </div>
                        <div className="col-md-6">
                          {isDocShow ? (
                            // Document viewer when isDocShow is true
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <div className="row p-2 align-items-center">
                                  <button
                                    className="btn btn-primary"
                                    disabled={isSideFrameLoading}
                                    onClick={() =>
                                      this.setState(
                                        {
                                          isSideFrameLoading: true,
                                        },
                                        () => {
                                          this.getFile(
                                            this.state.currentFileId,
                                            this.state.currentFileType,
                                          );
                                        },
                                      )
                                    }
                                  >
                                    <i
                                      className={`feather icon-refresh-cw ${isSideFrameLoading
                                          ? "fa fa-refresh fa-spin"
                                          : null
                                        }`}
                                      style={{ marginRight: 0 }}
                                    />
                                  </button>
                                  <button
                                    className="btn btn-primary ml-3"
                                    onClick={() => {
                                      const savedScrollPosition =
                                        this.state.scrollPosition;
                                      this.setState(
                                        { isDocShow: false },
                                        () => {
                                          // Restore scroll position so QA list shows where user clicked
                                          if (
                                            this.qaContainerRef.current &&
                                            savedScrollPosition !== undefined
                                          ) {
                                            setTimeout(() => {
                                              if (this.qaContainerRef.current) {
                                                this.qaContainerRef.current.scrollTop =
                                                  savedScrollPosition;
                                              }
                                            }, 100);
                                          }
                                        },
                                      );
                                    }}
                                  >
                                    Close
                                  </button>
                                </div>
                              </div>
                              <div
                                className="container mt-10"
                                style={{
                                  width: "100%",
                                  border: "1px solid #dee2e6",
                                  borderRadius: "8px",
                                }}
                              >
                                <Accordion className="mainAccordion">
                                  <Tabs
                                    defaultActiveKey="newViewerKey"
                                    style={{ padding: 0 }}
                                  >
                                    <Tab
                                      eventKey="newViewerKey"
                                      title="New Viewer"
                                    >
                                      <div style={{ display: "flex" }}>
                                        {document && isHightlightsLoaded ? (
                                          <div
                                            className="checklist-pdf-viewer"
                                            style={{
                                              height: "600px",
                                              width: "45vw",
                                              position: "relative",
                                            }}
                                          >
                                            <PDFHighlighter
                                              url={document}
                                              highlights={this.state.highlights}
                                              onHighlightsChange={() => { }}
                                            />
                                          </div>
                                        ) : (
                                          <CircularProgress
                                            style={{
                                              marginLeft: "50%",
                                              marginTop: "30%",
                                            }}
                                          />
                                        )}
                                      </div>
                                    </Tab>
                                    <Tab
                                      eventKey="oldViewerKey"
                                      title="Old Viewer"
                                    >
                                      <div
                                        className="form-document"
                                        style={{ overflowY: "scroll" }}
                                      >
                                        {document ? (
                                          <iframe
                                            key={this.state.fileFrameId}
                                            width="99%"
                                            height="520"
                                            frameBorder="0"
                                            src={document}
                                            title="workfile"
                                          ></iframe>
                                        ) : (
                                          <CircularProgress
                                            style={{
                                              marginLeft: "50%",
                                              marginTop: "30%",
                                            }}
                                          />
                                        )}
                                      </div>
                                    </Tab>
                                  </Tabs>
                                </Accordion>
                              </div>
                            </div>
                          ) : (
                            // Q&A/Form section when isDocShow is false
                            <div
                              ref={this.qaContainerRef}
                              className="container"
                              style={{
                                width: "100%",
                                height: "85vh",
                                overflow: "auto",
                                border: "1px solid #dee2e6",
                                borderRadius: "8px",
                              }}
                            >
                              <div className="row mt-10">
                                <div className="col-sm-6">
                                  <label>Date {""}    <span className="inputEgMsg">
                                    Eg. If the report date needs to be changed, please enter the required date manually.
                                  </span></label>
                                  <div className="d-flex align-items-center">
                                    <MaskedInput
                                      className="form-control"
                                      mask={[
                                        /[0-3]/,
                                        /\d/,
                                        ".",
                                        /[0-1]/,
                                        /\d/,
                                        ".",
                                        /[1-2]/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                      ]}
                                      placeholder="dd.mm.yyyy"
                                      value={date}
                                      onChange={(e) =>
                                        this.handleChange("date", e.target)
                                      }
                                      name="date"
                                    />
                                    {date && (
                                      <button
                                        type="button"
                                        className="btn btn-danger btn-sm ml-2"
                                        onClick={() =>
                                          this.setState({
                                            date: "",
                                            isEdited: true,
                                          })
                                        }
                                        title="Clear date"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        Clear
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* <div className="pt-2 pb-2">
                                {verifiedfile == "verification" ? (
                                  <MissingLOD
                                    data={data.missingLOD}
                                    handleLodChange={this.handleLodChange}
                                  />
                                ) : (
                                  ""
                                )}
                              </div> */}
                              <div className="mt-10">
                                <h6>
                                  <strong>Q &amp; A</strong>
                                </h6>
                                <table className="table table-striped no-shadow-table">
                                  <tbody>
                                    {qaList.map((qa: any, index) => {
                                      return (
                                        <React.Fragment key={qa.id}>
                                          {/* Main Q&A Row */}
                                          {this.QARow({
                                            qa,
                                            index,
                                            currentIndex,
                                            setCurrentIndex: (i) =>
                                              this.setState({
                                                currentIndex: i,
                                              }),
                                            handleqaChange: this.handleqaChange,
                                            questionHandleChange:
                                              this.questionHandleChange,
                                          })}

                                          {/* Render subItems in same response order */}
                                          {qa.subItems?.map(
                                            (item, subIndex) => {
                                              let content: any = null;

                                              switch (item.dropdownValue) {
                                                case "Schedule of Property":
                                                  content =
                                                    this.DescriptionOfProperty(
                                                      item.inputValue,
                                                    );
                                                  break;

                                                case "List of Documents (Scrutiny)":
                                                  content =
                                                    this.ListOfDocuments(
                                                      item.inputValue,
                                                      "scrutiny",
                                                    );
                                                  break;

                                                case "List of Documents (To Be Collected)":
                                                  content =
                                                    this.ListOfDocuments(
                                                      item.inputValue,
                                                      "toBeCollected",
                                                    );
                                                  break;

                                                case "Post Disbursement Documents":
                                                  content = this.PrePostRow(
                                                    item.inputValue,
                                                    this.state
                                                      .post_disbursal_list,
                                                    this.state.scrutinyList
                                                      .length,
                                                  );
                                                  break;

                                                case "Pre Disbursement Documents":
                                                  content = this.PrePostRow(
                                                    item.inputValue,
                                                    this.state
                                                      .pre_disbursal_list,
                                                    this.state.scrutinyList
                                                      .length +
                                                    this.state
                                                      .post_disbursal_list
                                                      .length,
                                                  );
                                                  break;

                                                case "Tracing of History":
                                                  content =
                                                    this.ReportParagraph(
                                                      this.state
                                                        .hasTracingHistory,
                                                      item.inputValue,
                                                    );
                                                  break;

                                                case "Tracing Possession":
                                                  content =
                                                    this.ReportParagraph(
                                                      this.state
                                                        .hasTracingPossession,
                                                      item.inputValue,
                                                    );
                                                  break;

                                                case "Tracing of Sale Agreement":
                                                  content =
                                                    this.ReportParagraph(
                                                      this.state
                                                        .hasTracingSaleAgreement,
                                                      item.inputValue,
                                                    );
                                                  break;

                                                case "Tracing Encumbrance Certificate":
                                                  content =
                                                    this.ReportParagraphTracingEC(
                                                      item.inputValue,
                                                    );
                                                  break;

                                                case "In finally Paragraph":
                                                  content = this.ECinFinal(
                                                    item.inputValue,
                                                  );
                                                  break;

                                                case "There Such Paragraph":
                                                  content = this.ThereSuch(
                                                    item.inputValue,
                                                  );
                                                  break;

                                                case "Remarks":
                                                  content = this.Remarks(
                                                    item.inputValue,
                                                  );
                                                  break;

                                                default:
                                                  return null;
                                              }

                                              return this.renderAccordionSection(
                                                item.inputValue ||
                                                item.dropdownValue,
                                                content,
                                                subIndex,
                                              );
                                            },
                                          )}
                                        </React.Fragment>
                                      );
                                    })}

                                    {this.state.qaList.length === 0 && (
                                      <tr>
                                        <td>
                                          There is no Q &amp; A for this file.
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal"
          id="final-approval-model"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                {/* <p><strong style={{ fontSize: '20px' }}>Checklist</strong></p> */}
                <p>
                  <strong style={{ fontSize: "20px" }}>
                    Are you sure you want to give final approval to this file?
                  </strong>
                </p>
                <button className="close" data-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>

              <div
                className="modal-body"
                style={{ height: "70vh", overflow: "auto" }}
              >
                {/* -------- General Details -------- */}
                <div className="mb-3">
                  <strong>General Details:</strong>
                  {this.state.checklist.generalDetails.map((item, index) => (
                    <label key={index} className="d-block">
                      <input
                        className="mr-2 mt-2"
                        type="checkbox"
                        checked={item.checked}
                        onChange={() =>
                          this.handleChecklistGroupChange(
                            "generalDetails",
                            index,
                          )
                        }
                      />
                      {item.label}
                    </label>
                  ))}
                </div>

                {/* -------- Schedule of Property -------- */}
                <div className="mb-3">
                  <strong>Schedule of Property:</strong>
                  {this.state.checklist.scheduleOfProperty.map(
                    (item, index) => (
                      <label key={index} className="d-block">
                        <input
                          className="mr-2  mt-2"
                          type="checkbox"
                          checked={item.checked}
                          onChange={() =>
                            this.handleChecklistGroupChange(
                              "scheduleOfProperty",
                              index,
                            )
                          }
                        />
                        {item.label}
                      </label>
                    ),
                  )}
                </div>

                {/* -------- Tracing of History -------- */}
                <div className="mb-3">
                  <strong>Tracing of History:</strong>
                  {this.state.checklist.tracingOfHistory.map((item, index) => (
                    <label key={index} className="d-block">
                      <input
                        className="mr-2  mt-2"
                        type="checkbox"
                        checked={item.checked}
                        onChange={() =>
                          this.handleChecklistGroupChange(
                            "tracingOfHistory",
                            index,
                          )
                        }
                      />
                      {item.label}
                    </label>
                  ))}
                </div>

                {/* -------- Tracing of Possession -------- */}
                <div className="mb-3">
                  <strong>Tracing of Possession:</strong>
                  {this.state.checklist.tracingOfPossession.map(
                    (item, index) => (
                      <label key={index} className="d-block">
                        <input
                          className="mr-2  mt-2"
                          type="checkbox"
                          checked={item.checked}
                          onChange={() =>
                            this.handleChecklistGroupChange(
                              "tracingOfPossession",
                              index,
                            )
                          }
                        />
                        {item.label}
                      </label>
                    ),
                  )}
                </div>

                {/* -------- Encumbrance Certificate -------- */}
                <div className="mb-3">
                  <strong>Encumbrance Certificate:</strong>
                  {this.state.checklist.encumbranceCertificate.map(
                    (item, index) => (
                      <label key={index} className="d-block">
                        <input
                          className="mr-2  mt-2"
                          type="checkbox"
                          checked={item.checked}
                          onChange={() =>
                            this.handleChecklistGroupChange(
                              "encumbranceCertificate",
                              index,
                            )
                          }
                        />
                        {item.label}
                      </label>
                    ),
                  )}
                </div>

                {/* -------- List of Documents --------  */}
                <div className="mb-3">
                  <strong>List of Documents:</strong>
                  {this.state.checklist.documentList.map((item, index) => (
                    <label key={index} className="d-block">
                      <input
                        className="mr-2  mt-2"
                        type="checkbox"
                        checked={item.checked}
                        onChange={() =>
                          this.handleChecklistGroupChange("documentList", index)
                        }
                      />
                      {item.label}
                    </label>
                  ))}
                </div>

                {/* -------- Error location Dropdown --------  */}
                <div className="mb-3">
                  <strong>Error Location:</strong>
                  <Select
                    options={this.state.errorLocationOptions}
                    name="errorLocations"
                    closeMenuOnSelect={false}
                    isMulti
                    value={this.state.selectedErrorLocations}
                    onChange={this.handleErrorLocationChange}
                    placeholder="Select error locations..."
                    className="mt-2"
                  />
                </div>

                <div className="mb-3">
                  <strong>Error Details:</strong>
                  <textarea
                    name="errorDetails"
                    value={this.state.errorDetails}
                    onChange={this.handleErrorDetailsChange}
                    placeholder="Error details"
                    className="form-control"
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={this.confirmCompleteFinalApproval}
                  disabled={this.state.isFinalApprovalLoading}
                >
                  {/* Complete */}
                  Yes
                </button>

                <button className="btn btn-secondary" data-dismiss="modal">
                  {/* Cancel */}
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
        <VerificationEOD
          verify={verification}
          setVerify={this.setVerify}
          saveUploadData={this.uploadDoc}
        />
        <div className="modal" id="complete-process">
          <div className="modal-dialog ">
            <div className="modal-content">
              <div className="modal-body">
                <h3>Without upload document you can't complete the file</h3>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                >
                  {" "}
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal" id="reason-modal">
          <div className="modal-dialog ">
            <div className="modal-content">
              <div className="modal-header">
                {action === "download" ? (
                  <h5 className="modal-title">Reason For Download</h5>
                ) : (
                  <h5 className="modal-title">Reason For Upload</h5>
                )}
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div>
                  {action === "download" ? (
                    <label>Enter Reason*</label>
                  ) : (
                    <React.Fragment>
                      <label>Enter Updated Informations*</label>
                      <ReactFileReader
                        fileTypes={[".doc", ".docx"]}
                        base64={true}
                        handleFiles={(e) => this.uploadFile(e)}
                      >
                        <button className="ml2 btn btn-success btnupload">
                          Select File
                        </button>
                      </ReactFileReader>
                      <span>{uploadFile.fileList[0].name}</span>
                    </React.Fragment>
                  )}
                  <textarea
                    className="form-control mt-10"
                    name="reason"
                    value={reason}
                    onChange={this.handleReasonChange}
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn " data-dismiss="modal">
                  Cancel
                </button>
                {action === "download" ? (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.validateReason}
                  >
                    Download
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.validateReason}
                  >
                    Upload
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="holdModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{
              maxWidth: "800px",
              maxHeight: "660px",
              overflow: "scroll",
            }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5>
                  Are you sure you want to hold {this.props.match.params.id}?
                </h5>
              </div>
              {this.state.holdVal && (
                <>
                  <div className="modal-body">
                    <p style={{ textAlign: "center", color: "black" }}>
                      Please Select Type and Provide Reason to Hold the File
                    </p>

                    {/* --- Added Select Field --- */}
                    <div
                      className="form-group"
                      style={{
                        width: "98%",
                        margin: "auto",
                        marginBottom: "10px",
                      }}
                    >
                      <select
                        className="form-control"
                        name="holdType"
                        disabled
                        value={this.state.holdType || "Hold"}
                        onChange={this.onchange}
                      >
                        <option value="">-- Select Hold Type --</option>
                        <option value="Hold">Hold</option>
                        {/* <option value="Hold Query Raised">
                                      Hold Query Raised
                                    </option> */}
                      </select>
                      {isEmpty(this.state.holdType) ? (
                        <p
                          style={{
                            color: "red",
                            textAlign: "center",
                            fontSize: "16px",
                            marginTop: "5px",
                          }}
                        >
                          Please select a hold type
                        </p>
                      ) : null}
                    </div>

                    {/* {!isEmpty(this.state.holdType) &&
                                  this.state.holdType == "Hold Query Raised" &&
                                  newQueryList && (
                                    <>
                                      <div
                                        className="raise-query-style"
                                        style={{ marginTop: "4%", flex: 1 }}
                                      >
                                        <QueryAdd
                                          addnewQueryList={newQueryList}
                                          handleChange={this.handleChangequery}
                                          handleDetailsChange={this.handleDetailsChange}
                                          removeReply={this.removeReply}
                                          newaddrequery={this.newaddrequery}
                                          queryreason={this.state.reasons}
                                        />
                                      </div>
                                    </>
                                  )} */}

                    {/* --- Existing Reason Field --- */}
                    <div
                      className="form-group"
                      style={{ width: "98%", margin: "auto" }}
                    >
                      <textarea
                        className="form-control"
                        placeholder="Type Your Reason"
                        name="holdreason"
                        value={this.state.holdreason}
                        onChange={this.onchange}
                      />
                      {isEmpty(this.state.holdreason) ? (
                        <p
                          style={{
                            color: "red",
                            textAlign: "center",
                            fontSize: "16px",
                          }}
                        >
                          Please type your reason
                        </p>
                      ) : null}
                    </div>
                  </div>
                </>
              )}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.handleHoldFile()}
                >
                  {this.state.isLoading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : (
                    "Yes"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.renderConfirmModal()}
        {this.renderExitConfirmModal()}
      </div>
    );
  }
}

export default WorkFileDetails;
